import { Center, Loader, Paper, Stack, Text, Anchor } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import LoginLogoutApi from '../../api/LoginLogoutApi';

export const SupportLogin = () => {

  useDocumentTitle('Visiopt - Support Login');
  const navigate = useNavigate();
  const location = useLocation();
  const { login, userRolePermissions } = useAuth();

  const [errorMessage, setErrorMessage] = useState('');
  // the token is single use, so the redeem call must never run twice
  const redeemStarted = useRef(false);

  useEffect(() => {
    if (redeemStarted.current) {
      return;
    }
    redeemStarted.current = true;

    const token = new URLSearchParams(location.search).get('token');
    // drop the token from the address bar so it is not kept in history or sent as a referrer
    window.history.replaceState({}, document.title, window.location.pathname);

    if (!token) {
      setErrorMessage('This support login link is invalid.');
      return;
    }

    LoginLogoutApi.supportlogin({ token: token })
      .then(APIResponse => APIResponse.text())
      .then(APIResult => {
        const APIResultJSON = JSON.parse(APIResult);
        if (APIResultJSON.status !== 1) {
          setErrorMessage(APIResultJSON.message);
          return;
        }

        login();
        localStorage.setItem('visiUserData', btoa(JSON.stringify(APIResultJSON.data)));
        localStorage.removeItem('visiMemberData');

        let userPermissions: any = [];
        const member_user_permission = APIResultJSON.data.access_permission;
        if (member_user_permission) {
          for (const role in member_user_permission) {
            userPermissions = member_user_permission[role];
          }
        }
        userRolePermissions(userPermissions);

        // support never goes through the customer onboarding or account setup wizards
        if (APIResultJSON.data.next_page === 'billing') {
          navigate('/billing-details');
        } else {
          navigate('/dashboard');
        }
      })
      .catch(() => {
        setErrorMessage('Could not start the support session. Please try again from the Admin panel.');
      });
  }, [location.search, login, navigate, userRolePermissions]);

  return (
    <Center style={{ height: '100vh' }}>
      <Paper p="xl" withBorder>
        <Stack align="center" spacing="md">
          {errorMessage === '' ? (
            <>
              <Loader />
              <Text>Starting support session...</Text>
            </>
          ) : (
            <>
              <Text color="red">{errorMessage}</Text>
              <Anchor href={process.env.REACT_APP_OLD_VISIOPT_BASE_URL + 'admin/index.php?pag=member_list'}>Return to Admin</Anchor>
            </>
          )}
        </Stack>
      </Paper>
    </Center>
  );
};
